export default "__VITE_ASSET__D81wAkb8__"